import React from "react";
import { Tooltip } from "@arco-design/web-react";

export const HEADLESS_APP_LABELS = {
  title: "Headless App Logs",
  deviceList: "Device List",
  accountList: "Account List",
  source: "Source",
  docType: "Doc Type",
  date: "Date",
  filter: "Filter",
  reset: "Reset",
  download: "Download",
  selectDevice: "Select Device",
  selectAccount: "Select Client",
  selectSource: "All Sources",
  selectDocType: "All Doc Types",
  errorDownload: "Something went wrong while downloading",
  errorDownload2: "Error downloading summary:",
  errorDeviceFetch: "Failed to load devices",
  errorDeviceFetch2: "Error fetching Device list:",
  errorAccountFetch: "Failed to load client list",
  errorAccountFetch2: "Error fetching client list:",
  errorFilterFetch: "Failed to load filter options",
  errorFilterFetch2: "Error fetching filter dropdown:",
  errorDataFetch: "Failed to fetch data",
  errorSummaryFetch: "Error fetching summary:",
  status: "Status",
  selectStatus: "All Status",
};

export const HEADLESS_APP_COLUMNS = (convertDateTime) => [
  { title: "Client Name", dataIndex: "clientName" },
  { title: "Document Type", dataIndex: "docType" },
  { title: "Source", dataIndex: "source" },
  { title: "Device Id", dataIndex: "deviceId" },
  {
    title: "Date",
    dataIndex: "formattedDateTime",
    render: (_, record) => convertDateTime(record.formattedDateTime),
  },
  { title: "Status", dataIndex: "status" },
  {
    title: "Remarks",
    dataIndex: "remarks",
    render: (_, record) => (
      <Tooltip content={record.remarks}>
        <div
          style={{
            width: "230px",
            display: "-webkit-box",
            WebkitLineClamp: 1,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
            cursor: "pointer",
          }}
        >
          {record.remarks || "-"}
        </div>
      </Tooltip>
    ),
  },
];

export const DEFAULT_PAGINATION = {
  current: 1,
  pageSize: 10,
};

export const DEFAULT_FILTERS = {
  startDate: null,
  endDate: null,
  deviceId: "",
  clientId: "",
  source: "",
  docType: "",
  status: "",
};
